"use client";
import { useContext, useState } from "react";

import Caroussel from "@/components/caroussel";
import SellsForm from "@/components/sells-form";

import card1 from "@/assets/cofferts/premium/card1.jpeg";
import card2 from "@/assets/cofferts/premium/card-2.png";
import card3 from "@/assets/cofferts/premium/card-3.png";

import Container from "@/components/ui/Container";
import { useRouter } from "next/navigation";

import { getFieldPhoneValue, validateForm } from "@/lib/validation";

import { languageContext } from "@/contexts/language-context";
/* import { encryptQueryParams } from "@/lib/cryptage"; */
import { useCheckout } from "@/contexts/checkout-context";
import useStoreParamsCookies from "@/hooks/useStoreParamsCookies";
// translation

const CAROUSSEL_ITEMS = [
  {
    image: card1,
  },
  {
    image: card2,
  },
  {
    image: card3,
  },
];

const translation: any = {
  title: { fr: "Coffret Premium", ar: "Coffret Premium" },
  description: {
    fr: "Offrez tout le nécessaire pour laisser une impression mémorable avec un coffret multifonction qui sert de boîte à rangement à poser sur votre bureau",
    ar: "قدّم كل ما يلزم لترك انطباع لا يُنسى مع علبة متعددة الوظائف تعمل كصندوق تخزين يوضع على مكتبك",
  },

  doubleUsage: {
    fr: "Coffret à double utilisation",
    ar: "صندوق متعدد الاستخدامات",
  },
  calendar: {
    fr: "Calendrier",
    ar: "تقويم",
  },
  portFeuille: {
    fr: "Porte-feuille en cuir",
    ar: "محفظة جلدية",
  },
  personalizedCard: {
    fr: "Carte de visite digitale personnalisée",
    ar: "بطاقة أعمال رقمية مخصصة",
  },
  stylo: {
    fr: "Stylo",
    ar: "قلم حبر",
  },
  powerBank: {
    fr: "Power Bank 16000 MAH",
    ar: "",
  },
  usb: { fr: "Clé USB 16 GO", ar: "" },
  NamePoste: {
    fr: "Nom, prénom et intitulé de poste imprimés sur la carte",
    ar: "الاسم الكامل واللقب والمسمى الوظيفي مطبوعة على البطاقة",
  },
  Pesonalization: {
    ar: "تخصيص بطاقتك بشعارك الخاص",
    fr: "Personnalisation avec votre logo",
  },
  detailedStatictics: {
    fr: "Statistiques détaillées (Popcard Metrics)",
    ar: "إحصائيات مفصلة (مقاييس بوبكارد)",
  },
  liensPdfs: {
    fr: "Liens réseaux sociaux, documents PDF, Images, Vidéos, Lien de prise de rendez-vous, informations  de contact..",
    ar: "روابط الشبكات الاجتماعية، مستندات PDF، صور، فيديوهات، رابط لحجز المواعد، معلومات الاتصال",
  },
  colors: {
    fr: "Couleur de l'impression :",
    ar: "لون الطباعة",
  },
  fullName: {
    fr: "Nom et Prénom*",
    ar: "الاسم الكامل *",
  },
  enterprise: {
    fr: "Entreprise ou Métier*",
    ar: "الشركة أو الأعمال *",
  },
  email: { fr: "Adresse Email*", ar: "البريد الإلكتروني *" },
  phone: { fr: "Téléphone*", ar: "الهاتف" },
  address: {
    fr: "Adresse Exacte *",
    ar: "العنوان*",
  },
  city: {
    fr: "Ville *",
    ar: "المدينة *",
  },
  qty: {
    fr: "Quantité*",
    ar: "الكمية *",
  },
  codePromo: {
    fr: "Code Promo",
    ar: "كوبون",
  },
  livraison: {
    ar: "Livraison gratuite partout au maroc",
    fr: "توصيل مجاني في أي مكان في المغرب",
  },
  Confirmer: {
    ar: "تأكيد الطلب",
    fr: "Confirmer",
  },
  mad: { fr: "MAD", ar: "درهم" },
};

const PRODUCT = "coffretPremium";
const CoffretPremium = ({ params }: { params: any }) => {
  useStoreParamsCookies(params);
  const router = useRouter();
  const [, setCheckout] = useCheckout();
  const { lang } = useContext<any>(languageContext);

  const [fields, setFields] = useState<any>({
    fullName: {
      label: {
        fr: "Nom et Prénom*",
        ar: "الاسم الكامل *",
      },
      name: "Nom et Prénom",
      placeholder: {
        fr: "Votre nom et prénom",
        ar: "أدخل إسمك الكامل",
      },
      value: "",
      error: { fr: "", ar: "" },
    },
    enterprise: {
      name: "Entreprise ou Métier",
      label: { fr: "Entreprise ou Métier*", ar: "الشركة أو الأعمال *" },
      placeholder: { fr: "Entreprise ou Métier", ar: "الشركة أو الأعمال" },
      value: "",
      error: { fr: "", ar: "" },
    },
    email: {
      name: "",
      label: { fr: "Adresse Email*", ar: "البريد الإلكتروني *" },
      placeholder: { fr: "Votre email", ar: "أدخل بريدك الإلكتروني" },

      value: "",
      error: { fr: "", ar: "" },
    },
    phone: {
      label: { fr: "Téléphone*", ar: "الهاتف" },
      placeholder: { fr: "Votre Téléphone", ar: "أدخل رقم هاتفك" },
      prefix: "+212",
      national: "",
      value: "",
      error: { fr: "", ar: "", en: "" },
    },
    address: {
      name: "Adresse",
      label: {
        fr: "Adresse Exacte *",
        ar: "العنوان*",
      },
      placeholder: { fr: "Votre adresse exacte", ar: "أدخل عنوانك" },
      value: "",
      error: { fr: "", ar: "" },
    },
    city: {
      name: "Ville",
      label: {
        fr: "Ville *",
        ar: "المدينة *",
      },
      placeholder: { fr: "Votre ville exacte", ar: "أدخل مدينتك" },
      value: "",
      error: { fr: "", ar: "" },
    },
    qty: {
      label: {
        fr: "Quantité*",
        ar: "الكمية *",
      },
      placeholder: "Votre nom et prénom",
      value: 1,
      type: "increment",
      error: { fr: "", ar: "" },
    },
    color: {
      name: "color",
      label: "color",
      placeholder: "",
      value: "gold",
      error: { fr: "", ar: "" },
    },
    promoCode: {
      name: "coupon",
      label: {
        fr: "Code Promo",
        ar: "كوبون",
      },
      placeholder: {
        fr: "Votre code Promo",
        ar: "كوبون",
      },
      value: "",
      error: { fr: "", ar: "" },
    },
  });

  const onSubmit = async (e: any) => {
    e.preventDefault();
    const isValidationError = await validateForm(
      fields,
      setFields,
      [
        "promoCode",
        "email",
        "phone",
        "city",
        "address",
        "enterprise",
        "fullName",
      ],
      "coffretPremium"
    );

    if (isValidationError) {
      return;
    }
    const data: any = {};
    Object.keys(fields).forEach((key) => {
      data[key] =
        key === "phone" ? getFieldPhoneValue(fields.phone) : fields[key].value;
    });

    setCheckout({ ...data, product: PRODUCT, params });
    router.push("/checkout");
    /* const objectToDcrypt: any = {};
    Object.keys(fields).forEach((key) => {
      objectToDcrypt[key] = fields[key].value;
    });

    const crypt = encryptQueryParams({
      ...objectToDcrypt,
      product: PRODUCT,
    });

    let url = `/checkout?query=${encodeURIComponent(crypt)}`;
    router.push(url); */
  };

  return (
    <>
      <Container className="grid grid-cols-6 gap-8 py-[5rem] items-start">
        <div className="col-span-6 sm:col-span-3 ">
          <Caroussel items={CAROUSSEL_ITEMS} className="w-full self-stretch" />
        </div>
        <SellsForm
          onSubmit={onSubmit}
          soldeOut={true}
          fields={fields}
          setFields={setFields}
          className="col-span-6 sm:col-span-3"
          name={translation.title}
          description={translation.description}
          checked={[
            translation.doubleUsage,
            translation.calendar,
            translation.portFeuille,
            translation.personalizedCard,
            translation.stylo,
            translation.usb,
          ]}
          whatsappMessage={false}
          unchecked={[]}
          colors={[
            { value: "gold", color: "#f9ca24" },
            { value: "silver", color: "#c8d6e5" },
            { value: "white", color: "#fff" },
          ]}
          oldPrice={650}
          currentPrice={550}
          isMetrics={false}
          // message={lang === "fr" ? "Quantités Limitées" : "كمية محدودة"}
        />
      </Container>
    </>
  );
};

export default CoffretPremium;
